const loadScript = (id, options, callback) => {
  if (!document.getElementById(id)) {
    const script = document.createElement('script')
    Object.keys(options).forEach(key => {
      script[key] = options[key]
    })
    script.id = id
    document.body.appendChild(script)

    script.onload = () => {
      if (callback) callback()
    }
  } else {
    callback(true)
  }
}

export default loadScript
